import { Extension, type Editor } from '@tiptap/react';
import type { TableOfContentData } from '@tiptap/extension-table-of-contents';

export const TOC_UPDATE_EVENT = 'toc-update';

export type TocUpdateEvent = CustomEvent<TableOfContentData>;

export type TocEventsStorage = {
  events: EventTarget;
  current: TableOfContentData;
};

declare module '@tiptap/react' {
  interface Storage {
    tocEvents: TocEventsStorage;
  }
}

export const TocEvents = Extension.create({
  name: 'tocEvents',

  addStorage(): TocEventsStorage {
    return {
      events: new EventTarget(),
      current: [],
    };
  },
});

export const isSameTocState = (previous: TableOfContentData, next: TableOfContentData) => {
  if (previous.length !== next.length) {
    return false;
  }

  return previous.every((item, index) => {
    const nextItem = next[index];
    return (
      item.id === nextItem.id &&
      item.level === nextItem.level &&
      item.textContent === nextItem.textContent &&
      item.isActive === nextItem.isActive &&
      item.isScrolledOver === nextItem.isScrolledOver
    );
  });
};

export const publishTocUpdate = (editor: Editor, tocData: TableOfContentData) => {
  const tocEvents = editor.storage.tocEvents;
  if (!tocEvents) {
    return;
  }

  if (isSameTocState(tocEvents.current, tocData)) {
    return;
  }

  tocEvents.current = tocData;
  tocEvents.events.dispatchEvent(
    new CustomEvent<TableOfContentData>(TOC_UPDATE_EVENT, {
      detail: tocData,
    })
  );
};
